<table mat-table [dataSource]="dataSource()">
  <ng-container matColumnDef="departmentName">
    <th mat-header-cell *matHeaderCellDef>Afdelingsnavn</th>
    <td mat-cell *matCellDef="let department" class="row">
      {{ department.departmentName }} {{ department.isHeadquarter ? '(Hovedkontor)' : '' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="accountNumber">
    <th mat-header-cell *matHeaderCellDef>
      <div class="icon-with-text">
        <span>G4 Kontonr.</span>
        <mat-icon class="outlined margin--left-s cursor-pointer" matTooltip="G4 Kontonr til for afdelingen.">info</mat-icon>
      </div>
    </th>
    <td mat-cell *matCellDef="let department" class="row">{{ department.invoicingAccountNumber }}</td>
  </ng-container>
  <ng-container matColumnDef="agreementNumber">
    <th mat-header-cell *matHeaderCellDef>
      <div class="icon-with-text">
        <span>G4 Aftalenr.</span>
        <mat-icon
          class="outlined margin--left-s"
          matTooltip="Det aftalenr., der er oprettet til lokationen i G4 og som også bruges i projekt id. Aftalenummeret anvendes til evt. forbrugsopkrævning, strømgodtgørelse og evt. elafgiftrefusion.">
          info
        </mat-icon>
      </div>
    </th>
    <td mat-cell *matCellDef="let department" class="row">{{ department.agreementNumber }}</td>
  </ng-container>
  <ng-container matColumnDef="group">
    <th mat-header-cell *matHeaderCellDef>Gruppe</th>
    <td mat-cell *matCellDef="let department" class="row">{{ department.departmentGroupName }}</td>
  </ng-container>
  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef>Adresse</th>
    <td mat-cell *matCellDef="let department" class="row">{{ department.address }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let department" class="row">
      <div class="actions-cell">
        <button mat-icon-button title="Rediger afdeling" (click)="editDepartment(department)">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
        </button>
        <button mat-icon-button class="delete" title="Slet afdeling" (click)="deleteDepartment(department)">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
        </button>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
  <tr
    mat-row
    *matRowDef="let department; columns: displayColumns"
    class="highlight-base"
    [class.highlight]="department.departmentId === highlightDepartmentId"></tr>
</table>
